
type BotResponse = {
  id: string;
  role: string;
};

export const expandAllElements = (): void => {
  const expandableElements = document.querySelectorAll('[aria-expanded="false"], [aria-hidden="true"]');
  expandableElements.forEach(element => {
    if (element instanceof HTMLElement) {
      element.setAttribute('aria-expanded', 'true');
      element.setAttribute('aria-hidden', 'false');
      element.style.display = 'block';
    }
  });

  const collapsibleSections = document.querySelectorAll('#collapsibleSection');
  collapsibleSections.forEach(section => {
    if (section instanceof HTMLElement && section.style.display === 'none') {
      section.style.display = 'block';
    }
  });
};

export const getSelectedMessagesHTML = (messages: BotResponse[], messageId?: string): string[] => {
  expandAllElements();
  return messages.filter(message => message.id === messageId).map(message => {
    const messageElement = document.getElementById(`message-${message.id}`);
    return messageElement ? messageElement.outerHTML : '';
  });
};

export const getAllMessagesHTML = (messages: BotResponse[], messageId?: string): string[] => {
  const messagesToExport = messageId ? getMessagesBetweenPrompts(messages, messageId) : getMessagesSinceLastPrompt(messages);
  console.log("Messages to export:", messagesToExport);

  return messagesToExport.map(message => {
    const messageElement = document.getElementById(`message-${message.id}`);
    console.log("messageElement", messageElement);
    if (messageElement && !messageElement.querySelector('#dropdownChoices')) {
      return messageElement.outerHTML;
    }
    return '';
  }).filter(html => html !== '');
};

export const getMessagesSinceLastPrompt = (messages: BotResponse[]): BotResponse[] => {
  const lastPromptIndex = messages.slice().reverse().findIndex(message => message.role === 'user');
  if (lastPromptIndex === -1) return messages; // Export all messages if no prompt found
  const startIndex = messages.length - 1 - lastPromptIndex;
  return messages.slice(startIndex + 1); // Export from last prompt to the end
};

export const getMessagesBetweenPrompts = (messages: BotResponse[], messageId: string): BotResponse[] => {
  const messageIndex = messages.findIndex(message => message.id === messageId);
  if (messageIndex === -1) return [];
  
  const previousPromptIndex = messages.slice(0, messageIndex).reverse().findIndex(message => message.role === 'user');
  const nextPromptIndex = messages.slice(messageIndex + 1).findIndex(message => message.role === 'user');
  
  const startIndex = previousPromptIndex === -1 ? 0 : messageIndex - previousPromptIndex;
  const endIndex = nextPromptIndex === -1 ? messages.length : messageIndex + nextPromptIndex + 1;
  
  return messages.slice(startIndex, endIndex);
};
